// Kurzer Dialog vor der Korrekturanfrage: der Grund geht in die Mail UND auf die
// Rechnung (korrektur_grund). Ohne Grund wüsste der Lieferant nicht, was zu korrigieren
// ist, und wir später nicht mehr, warum die Rechnung wartet.
import React, { useState } from 'react';
import { ArrowCounterClockwise } from '@phosphor-icons/react';
import { DialogHuelle } from '../immobilien/ui/DialogHuelle';
import { useMobilModus } from '../../lib/immobilien/mobil';

const VORSCHLAEGE = ['Falsches Objekt', 'Falscher Betrag', 'Falscher Empfänger', 'Falscher Leistungszeitraum'];

interface Props {
  rechnungsnummer: string;
  onClose: () => void;
  onWeiter: (grund: string) => void;
}

// Dialog im App-Stil (Rechnungen-Redesign E4, Screen 12): Grund-Vorschläge als Chips, Textfeld,
// „Weiter zur E-Mail“ erst mit Grund. Esc und Klick daneben schließen.
const KorrekturAnfordernModal: React.FC<Props> = ({ rechnungsnummer, onClose, onWeiter }) => {
  const [grund, setGrund] = useState('');
  const { mobil } = useMobilModus();
  const ok = !!grund.trim();

  return (
    <DialogHuelle titel="Korrektur anfordern" icon={ArrowCounterClockwise} iconFarbe={{ farbe: '#fff', flaeche: '#32ade6' }} onSchliessen={onClose} breite={460}
      fuss={
        <button type="button" onClick={() => onWeiter(grund)} disabled={!ok} className="inline-flex flex-1 items-center justify-center"
          style={{ height: 48, gap: 8, borderRadius: 15, border: 'none', cursor: ok ? 'pointer' : 'default', fontFamily: 'inherit', fontSize: 14, fontWeight: 800,
            background: 'var(--acc-fill)', boxShadow: ok ? 'var(--acc-sh)' : 'none', color: 'var(--acc-ink)', opacity: ok ? 1 : 0.45 }}>
          <ArrowCounterClockwise size={15} weight="bold" />Weiter zur E-Mail
        </button>
      }>
      <span style={{ fontSize: 13, lineHeight: 1.5, color: 'var(--ink2)' }}>
        Rechnung {rechnungsnummer}: Wir bitten den Lieferanten um eine korrigierte Fassung.
        Solange die Anfrage läuft, darf die korrigierte Rechnung mit derselben Nummer erfasst werden.
      </span>
      <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ink3)' }}>Grund</span>
      <div className="flex flex-wrap" style={{ gap: 6 }}>
        {VORSCHLAEGE.map((v) => {
          const an = grund === v;
          return (
            <button key={v} type="button" onClick={() => setGrund(v)} aria-pressed={an}
              style={{ height: mobil ? 44 : 32, padding: '0 12px', borderRadius: 16, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 700,
                background: an ? 'var(--acc-soft)' : 'var(--fill2)', color: an ? 'var(--acc)' : 'var(--ink2)' }}>
              {v}
            </button>
          );
        })}
      </div>
      <textarea value={grund} onChange={(e) => setGrund(e.target.value)} rows={3} aria-label="Grund"
        placeholder="z. B. Objekt Marburger Str. 2 statt Marburger Ring 55"
        style={{ width: '100%', resize: 'vertical', border: 'none', outline: 'none', borderRadius: 14, padding: '10px 12px', background: 'var(--fill)',
          boxShadow: 'inset 0 0 0 1px var(--line)', fontFamily: 'inherit', fontSize: 14, lineHeight: 1.5, color: 'var(--ink)' }} />
    </DialogHuelle>
  );
};

export default KorrekturAnfordernModal;
